module.exports = __webpack_public_path__ + "img/19451038000370.bfd67ff0.png";